// extracted by mini-css-extract-plugin
export default {"BoA-front-logo":"Frontpage_BoA-front-logo__Zl71n","BoA-individual-pages":"Frontpage_BoA-individual-pages__AjnsY"};